import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import authAPI from '../../services/authAPI';
import { useAuth } from '../../contexts/AuthContext';
import AuthShell, { buttonClass, Notice } from '../../components/Auth/AuthShell';

const VerifyEmailPage = () => {
  const { uid, token } = useParams();
  const { isAuthenticated } = useAuth();
  const [state, setState] = useState('verifying'); // verifying | done | failed
  const ran = useRef(false);

  useEffect(() => {
    // StrictMode mounts twice in development; verify once
    if (ran.current) return;
    ran.current = true;
    authAPI.verifyEmail(uid, token)
      .then(() => setState('done'))
      .catch(() => setState('failed'));
  }, [uid, token]);

  const next = isAuthenticated
    ? <Link to="/dashboard" className={buttonClass}>Go to your dashboard</Link>
    : <Link to="/login" className={buttonClass}>Sign in</Link>;

  if (state === 'verifying') {
    return (
      <AuthShell title="Verifying your email…">
        <div className="flex justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell title={state === 'done' ? 'Email verified' : 'Link not valid'}>
      <div className="space-y-6">
        {state === 'done'
          ? <Notice tone="success">Thanks! Your email address is confirmed.</Notice>
          : <Notice>This verification link is invalid or has expired. Links last 24 hours; you can keep using AirBrief in the meantime.</Notice>}
        {next}
      </div>
    </AuthShell>
  );
};

export default VerifyEmailPage;
